module.exports = __webpack_public_path__ + "static/media/Db6.57405e88.mp3";